/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Read/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import Content from './Content/index'
import Copy from 'DesignSystem/Copy/index'
import Delete from './Delete/index'
import DeleteAction from './DeleteAction/index'
import EditAction from './EditAction/index'
import Info from './Info/index'
import React from 'react'
import VisibleInSchedule from './VisibleInSchedule/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Read({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read"
  
}) {
let appointmentNoteItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note_item',
path: 'isLast',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let appointmentNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
path: 'note',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Read.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-bcq1': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-bcq1': dtColorsNeutral100,'--bc-6-bcq1': dtColorsNeutral300,'--bblr-7-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-8-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-9-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-10-bcq1': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-11-bcq1': appointmentNoteItemIsLastValueData ? "0px" : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<div
  data-testid="Read.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 fill={dtColorsNeutral400}
 marginLeft={0}
 data="appointment_note.note"
 value={appointmentNoteNoteValueData}
 text="Copy note"
/>
<Info
  viewPath={`${viewPath}/Info`}
/>
<VisibleInSchedule
  viewPath={`${viewPath}/VisibleInSchedule`}
/>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
{children}
</React.Fragment>)
}